<template>
  <div
    class="template-tabs"
    :id="content.key"
    :style="{
      fontFamily: content.templateStyle.fontFamily || '',
      fontSize: (content.templateStyle.fontSize + 'rem') || '',
      lineHeight: (content.templateStyle.lineHeight + 'rem') || '',
      textIndent: (content.templateStyle.textIndent && typeof content.templateStyle.textIndent === 'string') ? content.templateStyle.textIndent :
        (content.templateStyle.textIndent && typeof content.templateStyle.textIndent === 'number') ? (content.templateStyle.textIndent + 'rem') : '',
      fontWeight: content.templateStyle.fontWeight || '',
      textDecoration: content.templateStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.templateStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.templateStyle.textAlign || '',
      color: content.templateStyle.color || '',
      backgroundColor: content.templateStyle.backgroundColor || '',
      marginTop: (typeof content.templateStyle.marginTop === 'number' && (content.templateStyle.marginTop + 'rem')) || '',
      marginBottom: (typeof content.templateStyle.marginBottom === 'number' && (content.templateStyle.marginBottom + 'rem')) || '',
      padding: (typeof content.templateStyle.padding === 'number' && (content.templateStyle.padding + 'rem')) || '',
      paddingTop: (typeof content.templateStyle.paddingTop === 'number' && (content.templateStyle.paddingTop + 'rem')) || '',
      paddingBottom: (typeof content.templateStyle.paddingBottom === 'number' && (content.templateStyle.paddingBottom + 'rem')) || '',
      borderRadius: (typeof content.templateStyle.borderRadius === 'number' && (content.templateStyle.borderRadius + 'rem')) || '',
      border: content.templateStyle.border || '',
      borderTop: content.templateStyle.borderTop || '',
      borderBottom: content.templateStyle.borderBottom || '',
    }"
  >
    <div class="tabs-box-1">
      <div class="tabs-list-1">
        <div
          v-for="(item, index) in content.content"
          :key="item.key"
          class="tabs-item-1"
          :class="activeTabs1 === index ? 'tabs-item-1-active' : ''"
          @click="activeTabs1Handle(index)"
        >{{ item.text }}</div>
      </div>
      <div class="tabs-content-1">
        <div
          class="tabs-list-2"
          :style="{
            width: content.content[activeTabs1].tab2Width ? (content.content[activeTabs1].tab2Width + 'rem') : 'auto',
          }"
        >
          <div
            v-for="(item, index) in content.content[activeTabs1].content"
            :key="item.key"
            class="tabs-item-2"
            :class="activeTabs2 === index ? 'tabs-item-2-active' : ''"
            @click.stop="activeTabs2Handle(index)"
            :style="{
              width: (item.width + 'rem') || '',
              borderBottom: (typeof item.borderBottom === 'number' && `${item.borderBottom}rem solid #E3E3E3`) || '',
              borderRight: (typeof item.borderRight === 'number' && `${item.borderRight}rem solid #E3E3E3`) || '',
            }"
          >{{ item.text }}</div>
        </div>
        <div class="tabs-content-2">
          <!-- <commonIndex :bookContent="content.content[activeTabs1].content[activeTabs2].content"  :key="`${content.content[activeTabs1].content[activeTabs2].key}-1`"></commonIndex> -->
          <template v-for="(item, index) in content.content">
            <template v-for="(items, indexs) in item.content">
              <commonIndex v-show="activeTabs1 === index && activeTabs2 === indexs" :bookContent="content.content[index].content[indexs].content" :key="items.key"></commonIndex>
            </template>
          </template>
        </div>
      </div> 
    </div> 
  </div>
</template>

<script>
/*
两级tab栏结构
*/
export default {
  name: "tabsLevel2",
  components: {
    commonIndex: () => import("../../index.vue"), //解决递归加载组件报错
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      activeTabs1: 0,
      activeTabs2: 0,
    }
  },
  methods: {
    activeTabs1Handle(index) {
      this.activeTabs1 = index;
      this.activeTabs2 = 0;
    },
    activeTabs2Handle(index) {
      this.activeTabs2 = index;
    }
  }
}
</script>

<style lang="scss" scoped>
.template-tabs{
  width: calc(100% - 48rem);
  margin: 0 auto;
  border: 1px solid #5CA683;
  box-shadow: 0px 3px 8px 0px rgba(0,0,0,0.1);
  background: #fff;

  .tabs-box-1{
    .tabs-list-1{
      border: 1px solid #5CA683;
      border-right: 0;
      border-left: 0;
      display: flex;
      background: #F0F8F5;

      .tabs-item-1{
        flex: 1;
        font-size: 30rem;
        line-height: 38rem;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16rem 0;
        font-family: 'Calibri';
        text-align: center;
        cursor: pointer;
      }

      .tabs-item-1-active{
        background: #5CA683;
        color: #fff;
      }
    }

    .tabs-content-1{
      padding: 15rem 20rem;
      .tabs-list-2{
        border: 1px solid #E3E3E3;
        border-radius: 10rem;
        margin-bottom: 15rem;
        display: inline-block;
        cursor: pointer;

        .tabs-item-2{
          display: inline-block;
          color: #666;
          font-family: 'Calibri';
          font-weight: bold;
          font-size: 28rem;
          line-height: 38rem;
          padding: 10rem 0;
          border-right: 1px solid #E3E3E3;
          text-align: center;
          white-space: nowrap;

          &:last-child{
            border: 0;
          }
        }

        .tabs-item-2-active{
          color: #5CA683;
        }
      }
    }
  }
}
</style>